export function fetchImages(movies) {
    return movies.map(filme => {
        try {
            const image = require(`./${filme.path}/${filme.logo}`);
            return { ...filme, image };
        } catch (e) {
            console.error(`Falha ao carregar imagem para ${filme.nome || filme.path}:`, e);
            return { ...filme, image: null };
        }
    });
}
